export const GET_CLUBS_DATA = "GET_CLUBS_DATA";
